import { render } from "./ConsentOptinUpdatePage.vue?vue&type=template&id=6b1e15b2&scoped=true"
import script from "./ConsentOptinUpdatePage.vue?vue&type=script&lang=js"
export * from "./ConsentOptinUpdatePage.vue?vue&type=script&lang=js"

import "./ConsentOptinUpdatePage.vue?vue&type=style&index=0&id=6b1e15b2&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b1e15b2"]])

export default __exports__